import * as Types from './actionTypes';

export const paid = (
  id,
  token,
  cardLastDigits,
  method,
  expiryDate,
  amount,
  currency,
  securityCode,
  userCardType,
) => ({
  type: Types.PAID,
  payload: {
    id,
    token,
    cardLastDigits,
    method,
    expiryDate,
    amount,
    currency,
    securityCode,
    userCardType,
  },
});

export const authorized = () => ({
  type: Types.AUTHORIZED,
});

export const authorizedCallback = (
  response,
  message = 'Authorization for payment failed',
  shipmentId,
) => ({
  type: Types.AUTHORIZED_CALLBACK,
  payload: {
    response,
    message,
    shipmentId,
  },
});
